import { Component, OnInit, Renderer2, HostListener, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../loader/loader.service';
import _ from 'lodash';
import { MsalService } from '@azure/msal-angular';
import { delay, Observable, of } from 'rxjs';

@Component({
  selector: 'app-mode-year-vin-selection',
  templateUrl: './mode-year-vin-selection.component.html',
  styleUrls: ['./mode-year-vin-selection.component.scss']
})
export class ModeYearVinSelectionComponent implements OnInit {
  public routerPath = '';
  public hasFocus = false;
  public appName = environment.applicationName;
  public searchForm: FormGroup;
  public vehicleYear = [];
  public vehicleModel = [];
  public isSubmitted = false;
  public isInternal = false;
  public windowWidth: number = window.innerWidth;
  public showError = false;
  public vinOptions: string[] = [];
  public vinError = false;
  public vinNotAvalibaleError = false;
  public vinYearNotAvalibaleError = false;
  public modelCodeInfo: string = null;
  public featureType: string = null;
  public vinInOtherDivisionError = false;
  public resultLink = '';
  public resultLinkSet = false;
  public hideSelectionSection = false;
  public selectedVehicleModelName: any;
  public disableSearchButton = false;
  public isSearchButtonSubmitted = false;
  readonly homeURL = this.storageService.getFeatureType() === 'internal' ? `${this.appName}/home/internal` :
    `${this.appName}/home`;
  constructor(
    private router: Router, private fb: FormBuilder, private breadcrumbService: BreadcrumbService,
    public commonService: TCCPCommonService,
    private storageService: TCCPLocalStorageService,
    private loaderService: LoaderService, public authService: MsalService,
    public cdRef: ChangeDetectorRef) {
    this.commonService.hideModelYearSection.emit(false);
    this.vinOptions = this.storageService.getVinAutoSuggesstion()[this.appName];
    if (this.vinOptions) {
      this.vinOptions = this.vinOptions.reverse();
    }
    this.commonService.hideModelYearSection.emit(false);
    this.commonService.clearHomePage.subscribe((data) => {
      const vinKey = 'vin';
      const nameKey = 'name';
      let enteredVIN = this.storageService.getVin();
      if (typeof enteredVIN === 'object') {
        enteredVIN = enteredVIN && enteredVIN[nameKey];
      }
      if (data === 'MODEL') {
        if (enteredVIN) {
          this.searchForm.patchValue({
            model: '',
            year: '',
            vin: enteredVIN
          });
        }
        this.vehicleYear = [];
        this.onModelChange();
        this.searchForm.controls.vin.setValue(enteredVIN);
        const vehicleYear = this.storageService.getVehicleYear() && this.storageService.getVehicleYear().name;
        if (!vehicleYear) {
          this.storageService.setVehicleYear(null, null);
          this.breadcrumbService.clearBreadcrumb.emit(true);
          this.breadcrumbService.showBreadcrumb.emit(true);
        } else {
          this.storageService.setVehicleYear(Number(vehicleYear), this.homeURL);
          this.breadcrumbService.showBreadcrumb.emit(true);
        }
        this.searchForm.patchValue({
          year: ''
        });
        this.breadcrumbService.clearBreadcrumb.emit(true);
        this.breadcrumbService.showBreadcrumb.emit({ type: 'MODEL', show: true });
      } else if (data === 'YEAR') {
        if (this.router.url.includes('internal')) {
          this.onModelChange();
        }
        if (enteredVIN) {
          this.searchForm.patchValue({
            model: '',
            year: '',
            vin: enteredVIN
          });
        }
      } else if (data === vinKey) {
        if (this.router.url.includes('internal')) {
          this.onModelChange();
        }
        const vehicleVIN = this.storageService.getVehicleVin();
        if (vehicleVIN && vehicleVIN.name) {
          this.searchForm.controls.vin.setValue(vehicleVIN.name);
        }
      } else if (data === 'HOME') {
        this.vehicleYear = [];
        this.searchForm.patchValue({
          model: '',
          year: '',
          vin: ''
        });
      }
    },
      (error) => {
      });
  }

  focus() {
    this.hasFocus = true;
  }

  @HostListener('window: popstate', ['$event'])
  onPopState(event: Event): void {
    event.preventDefault();
    this.commonService.hideModelYearSection.emit(false);
  }

  ngOnInit() {
    this.routerPath = `${this.appName}/home`;
    this.hideSelectionSection = false;
    this.commonService.hideModelYearSection.subscribe(flag => {
      this.hideSelectionSection = flag;
    });
    this.featureType = this.storageService.getFeatureType();
    this.vinOptions = this.storageService.getVinAutoSuggesstion()[this.appName];
    if (this.vinOptions) {
      this.vinOptions = this.vinOptions.reverse();
    }
    this.commonService.enableFeedback = false;
    this.storageService.setMPCCode(null);
    this.commonService.showFeedback.emit({ showFeedback: false });
    environment.applicationName = this.appName;
    this.storageService.setHome(`${this.appName}/home/${this.featureType}`);
    this.commonService.setGTagPageDetails('Home', `${this.appName}/home`, window.location.href);
    this.storageService.setHome(this.homeURL);
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);
    const vinCharacterPattern = '^[a-zA-Z0-9]*$';
    this.commonService.landingPage = true;
    this.searchForm = this.fb.group({
      model: ['', Validators.required],
      year: ['', Validators.required],
      vin: ['', [Validators.required, Validators.pattern(vinCharacterPattern), Validators.minLength(17), Validators.maxLength(17)]]
    });
    const vehicleVIN = this.storageService.getVin() && this.storageService.getVehicleVin().name;
    let vehicleModel = this.storageService.getVehicleModel();
    let vehicleYear = this.storageService.getVehicleYear() && this.storageService.getVehicleYear().name;
    this.storageService.clearFlow();
    this.loaderService.show();
    if (vehicleVIN) {
      const appURl = window.location.href;
      if ((appURl && appURl.includes('model') && appURl.includes('year'))) {
      } else {
        this.storageService.setVehicleModel(null, null);
        this.storageService.setVehicleYear(null, null);
        this.storageService.setVehicleModelName(null);
        vehicleModel = this.storageService.getVehicleModel();
        vehicleYear = this.storageService.getVehicleYear() && this.storageService.getVehicleYear().name;
      }
      this.searchForm.patchValue({
        model: '',
        year: '',
        vin: vehicleVIN
      });
    }

    this.commonService.getModel().subscribe(data => {
      if (data) {
        // Temporary to exclude Solterra Model from public site.
        // TCCP-1854
        if (!this.isInternal) {
          for (let i = data.length - 1; i > -1; i--) {
            if (data[i].model.toUpperCase().includes('SUBARU')) {
              data.splice(i, 1);
            }
          }
        }
        this.loaderService.hide();
        this.vehicleModel = data;
        this.vehicleModel.sort((a, b) => {
          return a.model.localeCompare(b.model, 'en', { sensitivity: 'base' });
        });
        this.storageService.setModels(data);
        if (vehicleModel && vehicleModel.name) {
          this.searchForm.patchValue({
            model: vehicleModel.name
          });
          this.onModelChange();
          if (!vehicleYear) {
            this.storageService.setVehicleYear(null, null);
            this.breadcrumbService.clearBreadcrumb.emit(true);
            this.breadcrumbService.showBreadcrumb.emit(true);
          } else {
            this.storageService.setVehicleYear(Number(vehicleYear), this.homeURL);
            this.breadcrumbService.showBreadcrumb.emit(true);
          }
        } else {
          if (!vehicleYear) {
            this.vehicleYear = [];
            this.searchForm.patchValue({
              model: '',
              year: ''
            });
          }
        }
      }
    }, error => {
      this.loaderService.hide();
    });
  }

  async getVehicle(vin) {
    return await this.commonService.getVehicleInfo(vin);
  }

  public setCVSResponse(cvsResponse: any) {
    this.storageService.setVehicleModelYear(null);
    // set MPC, ModelCode and Model Year from CVS Response
    const brand: string = _.get(cvsResponse, 'summary.vehicleSummary.brand');
    this.isSubmitted = true;
    this.isSearchButtonSubmitted = true;
    if (!this.modelCodeInfo) {
      this.vinNotAvalibaleError = true;
      this.vinValidation();
      return;
    }
    this.commonService.setCVSDetails(cvsResponse, this.searchForm, this.featureType, this.homeURL);
    this.openDashBoard();
  }

  clearAllErrors() {
    this.vinError = false;
    this.vinNotAvalibaleError = false;
    this.vinYearNotAvalibaleError = false;
    this.vinInOtherDivisionError = false;
    this.resultLinkSet = false;
  }

  onVinSelected(value) {
    this.commonService.startLoaderEmitter.emit(true);
  }

  openDashBoard() {
    this.commonService.startLoaderEmitter.emit(true);
    this.isSubmitted = true;
    if ((this.searchForm.valid && this.isSubmitted) || (this.vinInOtherDivisionError && this.isSubmitted)) {
      if (this.searchForm.controls.vin.value && this.searchForm.controls.vin.value !== '') {
        this.storageService.setVin(this.searchForm.controls.vin.value);
        const url = this.featureType === 'internal' ? `${this.appName}/home/internal` : `${this.appName}/home`;
        this.storageService.setVehicleVin(this.searchForm.controls.vin.value, url);
      }
      let vinAutoSuggesstion = [];
      vinAutoSuggesstion = this.storageService.getVinAutoSuggesstion() ? this.storageService.getVinAutoSuggesstion()[this.appName] : null;
      if (vinAutoSuggesstion && vinAutoSuggesstion.length > 4) {
        vinAutoSuggesstion.shift();
      }
      if (vinAutoSuggesstion && vinAutoSuggesstion.indexOf(this.searchForm.controls.vin.value) === -1) {
        if (this.searchForm.controls.vin.value !== '') {
          vinAutoSuggesstion.push(this.searchForm.controls.vin.value);
          const autoSuggestion = {};
          autoSuggestion[this.appName] = vinAutoSuggesstion;
          this.storageService.setVinAutoSuggesstion(autoSuggestion);
        }
      }
      if (vinAutoSuggesstion === undefined) {
        if (this.searchForm.controls.vin.value !== '') {
          vinAutoSuggesstion = [];
          vinAutoSuggesstion.push(this.searchForm.controls.vin.value);
          const autoSuggestion = {};
          autoSuggestion[this.appName] = vinAutoSuggesstion;
          this.storageService.setVinAutoSuggesstion(autoSuggestion);
        }
      }
      this.breadcrumbService.clearBreadcrumb.emit(true);
      this.disableSearchButton = false;
      this.router.navigate([`${this.appName}/dashboard`]);
      this.loaderService.hide();
    }
  }

  public onSearch() {
     this.storageService.setBtVehicleModelName(null);
    this.isSearchButtonSubmitted = true;
    this.disableSearchButton = true;
    this.vinError = false;
    this.isSubmitted = true;
    this.showError = true;
    this.commonService.startLoaderEmitter.emit(true);
    this.clearAllErrors();
    const vinKey = 'vin';
    const yearKey = 'year';
    const modelKey = 'model';

    if (this.searchForm.controls.model.value && this.searchForm.controls.year.value &&
      this.searchForm.controls.vin.value && this.searchForm.controls.model.value === '' &&
      this.searchForm.controls.year.value === '' && this.searchForm.controls[vinKey].value === '') {
      this.showError = true;
      this.isSearchButtonSubmitted = false;
      this.disableSearchButton = false;
    } else if (this.searchForm.controls.vin.value && this.searchForm.controls.vin.value !== '') {
      if (this.searchForm.controls.vin.value.length === 17 && !this.searchForm.get(vinKey).hasError('pattern')) {
        const requestedVin = this.searchForm.controls.vin.value;
        const model = this.searchForm.get('model');
        const year = this.searchForm.get('year');
        this.storageService.setVin(requestedVin);
        this.storageService.setVehicleModel(null, null);
        this.storageService.setVehicleYear(null, null);
        const url = this.featureType === 'internal' ? `${this.appName}/home/internal` : `${this.appName}/home`;
        this.storageService.setVehicleVin(requestedVin, url);
        this.searchForm.patchValue({
          model: '',
          year: ''
        });
        this.searchForm.controls[modelKey].setValue('');
        this.searchForm.controls[yearKey].setValue('');
        model.setValidators(null);
        model.updateValueAndValidity();
        year.setValidators(null);
        year.updateValueAndValidity();

        // Adding VIN based search
        if (!_.isNil(this.storageService.getVin())) {
          const vin = this.storageService.getVin();
          this.commonService.getVehicleInfo(this.storageService.getVehicleVin().name).subscribe(async vinData => {
            if (vinData.summary === undefined){
              this.vinNotAvalibaleError = true;
            }
            else {
              this.vinNotAvalibaleError = false;
            }
            this.disableSearchButton = false;
            this.isSearchButtonSubmitted = false;
            this.commonService.vinDetails = vinData;
            this.storageService.setVehicleModelName(null);
            if (vinData.summary) {
              this.storageService.setVehicleGeneration(vinData.summary.vehicleSummary.generation, this.router.url);
              this.storageService.setModelCode(_.get(vinData, 'summary.vehicleSummary.modelCode'));
              this.commonService.vinSummaryDetails = vinData;
            }
            const modelVehicleDesc = _.get(vinData, 'summary.vehicleSummary.modeldescription');
            const modelYearFromVin = _.get(vinData, 'summary.vehicleSummary.modelYear');
            const brand: string = _.get(vinData, 'summary.vehicleSummary.brand');

            if (this.appName === 'toyota') {
              if (brand && brand !== 'TOY') {
                this.vinInOtherDivisionError = true;
                this.resultLink = await this.commonService.goToVinSearchResultLink(this.searchForm.controls['vin'].value, this.featureType);
                this.resultLinkSet = true;
                this.vinValidation();
                return;
              } else if (parseInt(modelYearFromVin, 10) < 2016) {
                this.clearAllErrors();
                this.vinYearNotAvalibaleError = true;
                this.vinValidation();
                return;
              }
            }
            if (this.appName === 'lexus') {
              if (brand && brand !== 'LEX') {
                this.vinInOtherDivisionError = true;
                this.resultLink = await this.commonService.goToVinSearchResultLink(this.searchForm.controls['vin'].value, this.featureType);
                this.resultLinkSet = true;
                this.vinValidation();
                return;
              } else if (parseInt(modelYearFromVin, 10) < 2016) {
                this.clearAllErrors();
                this.vinYearNotAvalibaleError = true;
                this.vinValidation();
                return;
              }
            }
            if (!this.vinYearNotAvalibaleError) {
              /* Setting Model Name in storage for Bluetooth Compatability */
              environment.applicationName = brand === 'LEX' ? 'lexus' : 'toyota';
              let numMatches = 0;
              this.commonService.getmodelName().subscribe(data => {
                data.forEach((element, index) => {
                  if (!_.isNil(this.storageService.getVin())) {
                    //Finds most specific match for vin searched model 
                    const vinModel = modelVehicleDesc.replace(/-/g, '').replace(/hv/gi, 'Hybrid').toUpperCase().split(" ");
                    const modelCompare = element.model.toUpperCase().split(" ");
                    const matches = modelCompare.filter(word => vinModel.includes(word)).length;
                    if (matches === modelCompare.length && matches > numMatches) {
                      numMatches = matches;
                      this.storageService.setVehicleModel(element.model, this.homeURL);
                      this.storageService.setVehicleModelName(element.model);
                      this.modelCodeInfo = element.model;
                    }
                  } else {
                    if (element.model === this.storageService.getVehicleModel().name) {
                      this.storageService.setVehicleModel(element.model, this.homeURL);
                      this.storageService.setVehicleModelName(element.model);
                    }
                  }
                  if (index === (data.length - 1)) {
                    if (!_.isEmpty(_.get(vinData, 'summary.vehicleSummary.vin'))) {
                      this.setCVSResponse(vinData);
                    } else {
                      this.isSubmitted = true;
                      this.clearAllErrors();
                      this.vinError = true;
                      this.isSearchButtonSubmitted = false;
                      window.scroll(0, 0);
                      return;
                    }
                  }
                });
              });
            }
          });
        }
        // VIN Search End
        this.showError = false;
      } else {
        this.showError = false;
        this.isSubmitted = true;
      }
    } else if (this.searchForm.controls.model.value && this.searchForm.controls.year.value) {
      if ((this.searchForm.controls[modelKey].value !== '' &&
        this.searchForm.controls[yearKey].value === '') || (this.searchForm.controls[modelKey].value !== '' &&
          this.searchForm.controls[yearKey].value !== '')) {
        const vin = this.searchForm.get(vinKey);
        vin.setValue(null);
        this.searchForm.patchValue({
          vin: ''
        });
        vin.setValidators(null);
        vin.updateValueAndValidity();
        this.showError = true;
        this.disableSearchButton = false;
        this.isSearchButtonSubmitted = false;
        if ((this.searchForm.controls[modelKey].value !== '' && this.searchForm.controls[yearKey].value !== '')) {
          this.storageService.setVin(null);
          this.storageService.setVehicleVin(null, null);
          this.openDashBoard();
        }
      }
    }
    this.loaderService.hide();
  }

  async setBrandErrors(brand, modelYearFromVin) {
    const selectedBrand = this.appName === 'toyota' ? brand !== 'TOY' : this.appName === 'lexus' ? brand && brand !== 'LEX' : brand;
    if (this.appName === 'toyota') {
      if (brand && brand !== selectedBrand) {
        this.vinInOtherDivisionError = true;
        this.resultLink = await this.commonService.goToVinSearchResultLink(this.searchForm.controls['vin'].value, this.featureType);
        this.resultLinkSet = true;
        this.vinValidation();
        return;
      } else if (parseInt(modelYearFromVin, 10) < 2016) {
        this.clearAllErrors();
        this.vinYearNotAvalibaleError = true;
        this.vinValidation();
        return;
      }
    }
    if (this.appName === 'lexus') {
      if (brand && brand !== 'LEX') {
        this.vinInOtherDivisionError = true;
        this.resultLink = await this.commonService.goToVinSearchResultLink(this.searchForm.controls['vin'].value, this.featureType);
        this.resultLinkSet = true;
        this.vinValidation();
        return;
      } else if (parseInt(modelYearFromVin, 10) < 2016) {
        this.clearAllErrors();
        this.vinYearNotAvalibaleError = true;
        this.vinValidation();
        return;
      }
    }
  }

  vinValidation() {
    this.isSubmitted = true;
    this.isSearchButtonSubmitted = false;
    this.storageService.setVehicleVin(null, null);
    this.storageService.setVin(null);
    this.storageService.setVehicleModel(null, null);
    this.storageService.setVehicleModelName(null);
    window.scroll(0, 0);
  }

  onVinKeyup(input) {
    this.isSubmitted = false;
    this.clearAllErrors();
    if (input && input === '') {
      this.clearAllErrors();
      const model = this.searchForm.get('model');
      const year = this.searchForm.get('year');
      this.searchForm.patchValue({
        model: '',
        year: ''
      });
      model.setValidators([Validators.required]);
      model.updateValueAndValidity();
      year.setValidators([Validators.required]);
      year.updateValueAndValidity();
    }
  }
  async getYearDetails(model): Promise<void> {
    await this.commonService.getYearDetails(model).then(data => {
      if (data) {
        this.loaderService.hide();
        this.vehicleYear = data;
        const vYear = this.storageService.getVehicleYear();
        if (vYear && vYear.name) {
          this.searchForm.patchValue({
            year: vYear.name
          });
        }
      }
    });
  }

  public onModelChange(event?) {
    this.isSubmitted = false;
    this.storageService.setBtVehicleVin('');
    this.storageService.setBtSearchedByVin(false);
    const vehicleModelName = this.vehicleModel.find(data => {
      return data.model === this.searchForm.get('model').value;
    });
    this.selectedVehicleModelName = vehicleModelName ? vehicleModelName.years : null;
    this.commonService.onModelChange(event, this.vehicleModel, this.vehicleYear, this.searchForm,
      this.selectedVehicleModelName, this.homeURL);
    this.getYearDetails(this.commonService.selectedModel.name);
  }

  ngAfterViewChecked() {
    this.commonService.landingPage = true;
    const hideModelYearSection = this.hideSelectionSection;
    if (hideModelYearSection !== this.hideSelectionSection) {
      this.hideSelectionSection = hideModelYearSection;
      this.cdRef.detectChanges();
    }
  }

  getTooltipContent() {
    return this.appName === 'toyota' ? 'toyota-vinToolTip' : 'lexus-vinToolTip';
  }

  public onYearChange(event) {
    this.isSubmitted = false;
    this.commonService.onYearChange(event, this.searchForm, this.selectedVehicleModelName,
      this.homeURL, this.router.url);
    this.storageService.setVehicleYear(event.target.value, this.homeURL);
    this.breadcrumbService.clearBreadcrumb.emit(true);
    this.breadcrumbService.showBreadcrumb.emit(true);
  }

}
